import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import axios from "../../axiosConfig";
import "../../styles/ExerciseModal.css";
import { AiOutlineClose } from "react-icons/ai"; // Close icon

const EditExerciseModal = ({ exercise, onClose, onSave }) => {
    const { t } = useTranslation(['exercises', 'common']);
    const [editForm, setEditForm] = useState({ ...exercise });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    // Mapping Polish difficulty levels to English ENUMs
    const difficultyMapping = {
        "Podstawowy": "BASIC",
        "Średniozaawansowany": "INTERMEDIATE",
        "Zaawansowany": "ADVANCED"
    };

    const handleChange = (e) => {
        setEditForm({ ...editForm, [e.target.name]: e.target.value });
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        try {
            const token = localStorage.getItem("jwt");

            // Convert difficulty level from Polish to English ENUM before sending to backend
            const updatedExercise = {
                ...editForm,
                difficultyLevel: difficultyMapping[editForm.difficultyLevel] || editForm.difficultyLevel,
            };

            await axios.put("/api/v1/exercise/update", updatedExercise, {
                headers: { Authorization: `Bearer ${token}` },
            });

            onSave(updatedExercise);
            onClose();
        } catch (err) {
            setError(t('exercises:updateError'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>{t('exercises:editExercise')}</h2>
                    <AiOutlineClose className="close-icon" onClick={onClose} />
                </div>
                <form onSubmit={handleSave}>
                    <div className="form-group">
                        <input type="text" name="name" value={editForm.name} onChange={handleChange} required placeholder={t('exercises:namePlaceholder')} />
                    </div>
                    <div className="form-group">
                        <input type="text" name="requiredEquipment" value={editForm.requiredEquipment} onChange={handleChange} placeholder={t('exercises:equipmentPlaceholder')} />
                    </div>
                    <div className="form-group">
                        <textarea name="description" value={editForm.description} onChange={handleChange} required placeholder={t('exercises:descriptionPlaceholder')} className="large-textarea" />
                    </div>
                    <div className="form-group">
                        <select name="difficultyLevel" value={editForm.difficultyLevel} onChange={handleChange}>
                            <option value="Podstawowy">{t('exercises:difficulty.basic')}</option>
                            <option value="Średniozaawansowany">{t('exercises:difficulty.intermediate')}</option>
                            <option value="Zaawansowany">{t('exercises:difficulty.advanced')}</option>
                        </select>
                    </div>
                    {error && <p className="error">{error}</p>}
                    <div className="modal-buttons">
                        <button type="button" className="cancel-btn" onClick={onClose}>{t('common:cancel')}</button>
                        <button type="submit" className="save-btn" disabled={loading}>
                            {loading ? t('common:saving') : t('exercises:saveChanges')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditExerciseModal;